import { isAuthenticated } from '@/event/account/auth/authentification'
import { idTimeout } from '@/event/account/idTimeout'
import { indexUpdateElement } from '@/event/cartBus'
import { theme } from '@/event/theme/theme'
import { ShowModalDisconnect } from '@/happyTheme/event/modalAccount/disconnected/showModalDisconnect'
import { excludeRouteApp } from '@/storage/navbar/excludeRoute'
import stores from '@/storage/stores'
import { loadData } from '@/utils/loadData'
import { catalogueBase, logo, settingNavbar } from '@/utils/main/navbar/statesNavbar'
import { useStoreInfo } from '@/utils/useStoreInfo'
import { watch } from 'vue'
import type { RouteLocationNormalizedLoaded } from 'vue-router'

const resetIndexUpdateElement = () => {
  indexUpdateElement.value = null
}

const { testDay, testHour, testMinute, updateStore } = useStoreInfo()

export function watchersApp(route: RouteLocationNormalizedLoaded) {
  watch(
    () => route.name,
    (newRoute, oldRoute) => {
      if (theme.value === 'happy-light' || theme.value === 'happy-dark') {
        if (newRoute && !isAuthenticated.value) {
          ShowModalDisconnect.value = false
        }
      } else if (theme.value === 'default') {
        const oldRouteValid = oldRoute
        if (oldRoute === 'error_urlchercker') {
          loadData()
        }

        if (idTimeout.value && oldRoute) {
          if (excludeRouteApp.includes(String(oldRouteValid))) {
            clearTimeout(idTimeout.value)
            idTimeout.value = null
          }
        }

      }

    }
  )

  watch(
    () => route.params,
    (newParams) => {
      if (newParams.product_id === undefined) {
        resetIndexUpdateElement()
      }
    }
  )

  watch([testDay, testHour, testMinute], () => {
    const data: any = stores.getStoresData()
    if (data) {
      updateStore(data)
    }
  })

  watch(
    () => stores.getStoresData(),
    (newValue) => {
      if (newValue && newValue.setting) {
        settingNavbar.value = stores.getStoresData().setting
        const logoItem = settingNavbar.value.find(
          (item: { key: string }) => item.key === 'config_logo'
        ).value

        logo.value = logoItem ?? null
      }

      if (newValue) {
        catalogueBase.value = stores.getStoresData().category
      }
    },
    { immediate: true }
  )


}
